import React, { useEffect } from "react";
import closeIcon from "../../../assets/crossIcon.svg";
import { formatDateTime } from "../../../utils/formatDateTimeUtil";

export default function ViewProcedureModal({ open, onClose, data, users }) {
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [open]);

  if (!open) return null;

  // Extract implant details from the implants array
  const implants = Array.isArray(data?.implantName) ? data.implantName : [];
  const implantNameDisplay = implants.map((imp) => imp.implantName).filter(Boolean).join(", ");
  const implantCostDisplay = implants.map((imp) => imp.implantCost).filter((c) => c != null).join(", ");

  // Extract tier costs from nested objects
  const tier1Cost = data?.tierCost1?.cost ?? "";
  const tier2Cost = data?.tierCost2?.cost ?? "";
  const tier3Cost = data?.tierCost3?.cost ?? "";

  // Resolve user UUIDs to names
  const createdByName = data?.createdBy
    ? (users?.[data.createdBy] ?? data.createdBy)
    : "";
  const updatedByName = data?.updatedBy
    ? (users?.[data.updatedBy] ?? data.updatedBy)
    : "";

  return (
    <div
      className="fixed inset-0 z-[9999] flex min-h-[100dvh] items-center justify-center overflow-y-auto overscroll-contain bg-[#5AC69F80] px-4 pb-10 pt-[calc(92px+24px)]"
      aria-modal="true"
      role="dialog"
    >
      <div className="relative w-[65%] max-w-[1000px] min-w-0 shrink-0 rounded-[28px] bg-white px-8 py-10 shadow-lg sm:px-12">
        {/* Close */}
        <button
          type="button"
          onClick={onClose}
          className="absolute top-6 right-6 bg-transparent border-none p-0"
        >
          <img src={closeIcon} alt="close" className="w-6 h-6" />
        </button>

        {/* Title */}
        <h2 className="text-center font-lufga font-medium text-[32px] leading-[100%] tracking-[-0.04em] text-black">
          View Procedure
        </h2>

        <div className="mt-6 border-t border-[#EDEDED]" />

        {/* Content */}
        <div className="mt-6 grid grid-cols-2 gap-x-20 gap-y-6">
          <Info label="Scheme" value={data?.scheme} />
          <div />

          <Info label="Speciality" value={data?.specialtyName} />
          <Info label="Speciality ID" value={data?.specialtyId} />

          <Info label="Procedure Name" value={data?.procedureName} />
          <Info label="Procedure ID" value={data?.procedureId} />

          <Info label="Country" value={data?.country || "India"} />
          <Info label="State" value={data?.state || ""} />

          <Info
            label="Created On"
            value={formatDateTime(data?.createdOn) || ""}
          />
          <Info label="Created By" value={createdByName} />

          <Info
            label="Updated On"
            value={formatDateTime(data?.updatedOn) || ""}
          />
          <Info label="Updated By" value={updatedByName} />

          <Info label="Implant Name" value={implantNameDisplay} />
          <Info label="Implant Cost" value={implantCostDisplay} />

          <Info label="Tier 1 Costing" value={tier1Cost} />
          <Info label="Tier 2 Costing" value={tier2Cost} />

          <Info label="Tier 3 Costing" value={tier3Cost} />
        </div>
      </div>
    </div>
  );
}

/* ===== Reusable row ===== */

function Info({ label, value }) {
  return (
    <div className="flex gap-2 text-[18px] leading-[140%]">
      <span className="font-lufga font-normal text-[#7A7A7A] whitespace-nowrap">
        {label} :
      </span>
      <span className="font-lufga font-medium text-black">{value || "-"}</span>
    </div>
  );
}
